
import { forwardRef, useEffect, useMemo, useRef } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { MDBCol, MDBRow } from "mdbreact";
import { Button, Label, TextArea } from "abs-ui-components";
import { commonFormFields } from "../../FeuConstants";
import { useParams } from "react-router";
import { API_ROUTES } from "../../FeuApiRoutes/FeuApiRoutes";
import { emitToasterMsg } from "../../../../../services/toasterUtility";
import { callApi } from "../../../../../services/MonitoringPlanService";
import AutoSave from "../../../../../common/AutoSave/AutoSave";
import { AUTOSAVE_SUCCESS_MESSAGE } from "../../../Mrv/Constants";
const FeuC18SailingInIce = forwardRef(({ c18SailingInIce, refetchMonitoringData,vesselMstId }, ref) => {
    const { control, getValues, reset, formState } = useFormContext();
    const lastManualSave = useRef(null);
    const manualSaveTriggered = useRef(false);
    const savedValuesRef = useRef({});
    const { dirtyFields } = formState;
    const isC18Dirty = !!(dirtyFields?.c18 && Object.keys(dirtyFields.c18).length > 0);

    useEffect(() => {
        if (c18SailingInIce) {
            reset(prev => ({ ...prev, c18: c18SailingInIce }));
        }
    }, [c18SailingInIce, reset]);


    const c18Fields = useMemo(() => {
        return commonFormFields.reduce((acc, field) => {
            if (field.name === "dataSources") return acc;
            if (field.name === "descriptionOfProcedure") {
                acc.push({
                    ...field,
                    label:
                        "Description of procedure (a brief description of the procedure can be provided if already existing outside the monitoring plan)",
                });
            } else {
                acc.push(field);
            }
            return acc;
        }, []);
    }, []);

    AutoSave(ref, [], async () => {
        const currentValues = getValues("c18");
        const isChanged = Object.keys(currentValues || {}).some(
            key => currentValues[key] !== savedValuesRef.current?.[key]
        );
        if (!isC18Dirty || !isChanged) return;
        await handleSave(true);
    });

    const handleSave = async (isAuto = false) => {
        const formValues = getValues("c18");
        const payload = {
            ...c18Fields.reduce((acc, { name }) => {
                acc[name] = formValues?.[name] || "";
                return acc;
            }, {}),
        };
        try {
            const C18SailingInIce = await callApi({
                method: "POST",
                url: API_ROUTES.C18(vesselMstId),
                data: payload,
            });
            if (C18SailingInIce?.isSuccess) {
                emitToasterMsg("success", "Table C.1.8", isAuto ? AUTOSAVE_SUCCESS_MESSAGE : "Created successfully");
                reset(prev => ({ ...prev, c1: formValues }));
                savedValuesRef.current = { ...formValues };
                if (!isAuto) {
                    lastManualSave.current = Date.now();
                }
                if (typeof refetchMonitoringData === "function") {
                    await refetchMonitoringData();
                }
            }
            else {
                emitToasterMsg("error", "Table C.1.8", C18SailingInIce?.errorMessage);
            }
        } catch (error) {
            emitToasterMsg("error", "Table C.1.8", error.errorMessage);
        }
    };


    return (
        <div className="b7-section-form mt-4">
            <MDBRow className="mb-2">
                <MDBCol md="4">
                    <h6 className="titles-font">Title of procedure</h6>
                </MDBCol>
                <MDBCol md="4">
                    <h6 className="titles-font">Monitoring fuel consumption of each fuel consumer when sailing in ice conditions</h6>
                </MDBCol>
            </MDBRow>
            {c18Fields.map(({ label, name, maxLength }, index) => (
                <MDBRow className="align-items-center mb-3" key={index}>
                    <MDBCol md="4">
                        <Label name={label} bold />
                    </MDBCol>
                    <MDBCol md="4">
                        <Controller
                            name={`c18.${name}`}
                            control={control}
                            render={({ field }) => (
                                <TextArea
                                    id={`c18_${name}`}
                                    className="textarea-resize"
                                    value={field?.value || ""}
                                    onChange={field.onChange}
                                    placeholder=""
                                    maxLength={maxLength}
                                    rows={1}
                                />
                            )}
                        />
                    </MDBCol>
                </MDBRow>
            ))}

            <div className="text-center">
                <Button id="c12_save_btn"
                    disabled={!isC18Dirty}
                    onClick={async () => {
                        manualSaveTriggered.current = true;
                        await handleSave(false);
                    }}
                >Save</Button>
            </div>
        </div>
    );
})

export default FeuC18SailingInIce;